import { createReducer } from '@reduxjs/toolkit';
import {
    addressSelectedAction,
    navigateDeliveryAction,
    setShipmentNotesAction,
    shipmentQuoteSelectedAction,
    toggleShipmentNotesAction,
} from '../actions/commonActions';
import { shipmentNotesErrorAction } from '../actions/checkoutDeliveryActions';

type DeliveryState = {
    isShipmentNoteOpen: boolean;
    isCustomQuoteSelected: boolean;
    needsShipmentNote: boolean;
    hasCustomQuoteError: boolean;
};
const initialState: DeliveryState = {
    isShipmentNoteOpen: false,
    isCustomQuoteSelected: false,
    needsShipmentNote: false,
    hasCustomQuoteError: false,
};

export const deliveryReducer = createReducer(initialState, builder => {
    builder
        .addCase(addressSelectedAction, state => {
            state.isCustomQuoteSelected = false;
            state.needsShipmentNote = false;
            state.hasCustomQuoteError = false;
        })
        .addCase(navigateDeliveryAction, state => {
            state.isShipmentNoteOpen = state.isCustomQuoteSelected || state.isShipmentNoteOpen;
        })
        .addCase(shipmentQuoteSelectedAction, (state, action) => {
            const { isCustomQuoteSelected } = action.payload;

            state.isShipmentNoteOpen = isCustomQuoteSelected || state.isShipmentNoteOpen;
            state.isCustomQuoteSelected = isCustomQuoteSelected;
            state.hasCustomQuoteError = false;
        })
        .addCase(toggleShipmentNotesAction, state => {
            state.isShipmentNoteOpen = state.isCustomQuoteSelected || !state.isShipmentNoteOpen;
        })
        .addCase(setShipmentNotesAction, (state, action) => {
            const { shipmentNotes } = action.payload || {};

            state.isShipmentNoteOpen = state.isCustomQuoteSelected || state.isShipmentNoteOpen;
            state.needsShipmentNote = state.isCustomQuoteSelected && !shipmentNotes;
            state.hasCustomQuoteError = state.isCustomQuoteSelected && !shipmentNotes;
        })
        .addCase(shipmentNotesErrorAction, state => {
            state.hasCustomQuoteError = true;
        });
});
